import { commentsItems } from '@/mocks/homeData';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-xl md:text-2xl lg:text-3xl font-heading font-bold text-foreground-950 mb-3">
            吃瓜热评
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            百万吃瓜群众的真实声音
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 max-w-5xl mx-auto">
          {commentsItems.map((item, i) => (
            <div key={i} className="bg-background-100 rounded-xl p-5">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-9 h-9 rounded-full bg-background-200 flex items-center justify-center text-lg flex-shrink-0">
                  {item.avatar}
                </div>
                <div className="flex-1 min-w-0">
                  <div className="text-sm font-semibold text-foreground-900">{item.name}</div>
                  <div className="text-xs text-foreground-400">{item.time}</div>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed mb-3">
                {item.content}
              </p>
              <div className="flex items-center gap-1 text-xs text-foreground-400">
                <i className="ri-heart-line text-primary-500"></i>
                <span>{item.likes}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}